import { UserNotificationsSystemItem } from '@infotech-soe/merps/types/Notifications';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { isBefore } from 'date-fns';

import {
  SingleSystemNotification,
  SystemNotificationsViewModel,
} from '../../models/notifications/Notifications';

import {
  emptyAction,
  failureAction,
  pendingAction,
  successAction,
} from './actionHandler';

const initialState: SystemNotificationsViewModel = {};

const systemNotificationsSlice = createSlice({
  name: 'systemNotifications',
  initialState,
  reducers: {
    received: emptyAction<UserNotificationsSystemItem>(),
    append: (state, { payload }: PayloadAction<SingleSystemNotification>) => {
      state[payload.id] = payload;
    },
    get: pendingAction(),
    getSuccess: successAction<
      SystemNotificationsViewModel,
      SystemNotificationsViewModel
    >((state, { payload }) => {
      Object.values(payload).forEach(
        notification => (state[notification.id] = notification)
      );
    }),
    getFailure: failureAction(),
    delete: (state, { payload }: PayloadAction<string>) => {
      delete state[payload];
    },
    clear: state => Object.keys(state).forEach(id => delete state[id]),
    update: (state, { payload }: PayloadAction<string[]>) => {
      const now = new Date();
      Object.values(state).forEach(({ id, ts }) => {
        if (!isBefore(now, ts)) state[id].toShow = true;
      });
      if (payload.length) payload.forEach(id => delete state[id]);
    },
  },
});

export const systemNotificationsReducer = systemNotificationsSlice.reducer;

export default systemNotificationsSlice.actions;
